import React from 'react';

import E100ButtonGroup, { IPropTypes } from 'e100-react-components/lib/components/ButtonGroup/ButtonGroup';

import { useStyles } from './styles';

import { mergeClasses } from 'shared/utils';

export const ButtonGroup = ({ classes, ...otherProps }: ButtonGroupProps) => {
  const innerClasses = useStyles();
  return (
    <E100ButtonGroup
      {...otherProps}
      classes={mergeClasses(innerClasses, classes)}
    />
  );
};

interface ButtonGroupProps extends IPropTypes {}
